<div class="legal-services-view">
    <h2 class="title">Legal Services</h2>
    <div class="table-wrapper">
      <table class="legal-services-table">
        <thead>
          <tr>
            <th><i class="fas fa-user"></i> Client</th>
            <th><i class="fas fa-briefcase"></i> Legal Service</th>
            <th><i class="fas fa-file-alt"></i> Description</th>
            <th><i class="fas fa-money-bill-wave"></i> Price</th>
            <th><i class="fas fa-check-circle"></i> Paid</th>
            <th><i class="fas fa-calendar-alt"></i> Start Date</th>
            <th><i class="fas fa-calendar-check"></i> End Date</th>
            <th><i class="fas fa-file-invoice"></i> Billed</th>
            <th><i class="fas fa-cogs"></i> Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Row 1 -->
          <tr *ngFor="let contract of getBachLegalClients()">
            <td>
                <div class="client-info">
                    <img src="https://via.placeholder.com/40" alt="Client Photo" class="client-photo" />
                    <span class="client-name">{{contract.name}} {{contract.lastname}}</span>
                  </div>
            </td>
            <td>{{contract.legalService}}</td>
            <td></td>
            <td>{{contract.price}} EUR</td>
            <td *ngIf="contract.paid=='0'"><span class="status pending">Pending</span></td>
            <td *ngIf="contract.paid=='1'"><span class="status paid">Paid</span></td>
            <td>{{contract.startDate}}</td>
            <td>{{contract.endDate}}</td>
            <td *ngIf="contract.billed=='0'" style="color: orange;">Pending</td>
            <td *ngIf="contract.billed=='1'" style="color: green;">Paid</td>
            <td>
                <button class="action-btn view">
                  <i class="fas fa-eye"></i> View
                </button>
                <button class="action-btn edit">
                  <i class="fas fa-edit"></i> Edit
                </button>
              </td>
          </tr>
          
        </tbody>
      </table>
    </div>
  </div>
  
